module.exports = __webpack_public_path__ + "media/images/logo-6a446a00dc4fcc957662fea43452effc.png";